import Loader from "../Loader/Loader";
import { KIND_LABELS } from "../../utilities/item-kinds";

export default function DeleteModal({
  kind,
  onCancel,
  onConfirm,
  isDeleting,
  error,
}) {
  const label = (KIND_LABELS[kind] || "item").toLowerCase();
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-ink/40" onClick={onCancel} />

      {/* Modal */}
      <div className="relative bg-paper rounded-2xl shadow-xl border border-ink/10 p-8 max-w-md w-[90vw]">
        <h3 className="font-display text-lg text-ink mb-2">Delete {label}</h3>
        <p className="font-serif text-sm text-ink/70 mb-6">
          Are you sure you want to delete this {label}? This cannot be undone.
        </p>
        {error && <p className="font-serif text-sm text-seal mb-4">{error}</p>}
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            disabled={isDeleting}
            className="px-4 py-2 text-sm font-medium rounded-lg border border-ink/25 text-ink/70 hover:border-ink/60 hover:text-ink transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isDeleting}
            className="px-4 py-2 text-sm font-medium rounded-lg bg-seal text-white hover:bg-seal-deep transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isDeleting ? <Loader /> : "Confirm Delete"}
          </button>
        </div>
      </div>
    </div>
  );
}
